import React, { memo, useCallback, useContext, useMemo } from 'react';
import isArray from 'lodash/isArray';
import isUndefined from 'lodash/isUndefined';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuServiceContext from '@signal/core/menuService/Context';
import { filterServiceMenuItemsForPopover, findActiveServiceMenuRootItemIndex } from '@signal/core/menuService/utils';
import trackPendo from '@signal/utils/pendo/track';
import stripQueryParams from '@signal/utils/stripQueryParams';
import PureCarsMeridianLogo from '../CommonHeader/PureCarsMeridianLogo';
import { InnerWrapper, LogoWrapper, MenuColumnWrapper, MenuWrapper, OuterWrapper, SubItemTypography } from './styles';
import { getColorPrimarySelector } from '@signal/theme/selectors';
import { useTheme } from '@material-ui/core/styles';
export function MultiAppMenuPanel(_ref) {
  var _ref$extraMenuItems = _ref.extraMenuItems,
      extraMenuItems = _ref$extraMenuItems === void 0 ? [] : _ref$extraMenuItems,
      location = _ref.location,
      onNavigate = _ref.onNavigate;
  var theme = useTheme();

  var _useContext = useContext(MenuServiceContext),
      _useContext$response = _useContext.response,
      serviceMenu = _useContext$response === void 0 ? [] : _useContext$response;

  var _useMemo = useMemo(function () {
    var navMenu = isArray(serviceMenu) ? filterServiceMenuItemsForPopover(serviceMenu).concat(extraMenuItems) : [];
    var activeValue = findActiveServiceMenuRootItemIndex(isArray(serviceMenu) ? serviceMenu : [], location.pathname);
    var subMenu = navMenu && !isUndefined(activeValue) && navMenu[activeValue].subMenuItems || []; // look for an exact match first, then take anything that starts with the path
    // look for an exact match first, then take anything that starts with the path

    var activeSubMenuItem = subMenu.find(function (_ref2) {
      var link = _ref2.link;
      return stripQueryParams(link) === location.pathname;
    }) || subMenu.find(function (_ref3) {
      var link = _ref3.link;
      return location.pathname.startsWith(stripQueryParams(link));
    });
    return {
      activeSubMenuLink: activeSubMenuItem && activeSubMenuItem.link,
      activeValue: activeValue,
      navMenu: navMenu,
      subMenu: subMenu
    };
  }, [extraMenuItems, location, serviceMenu]),
      activeValue = _useMemo.activeValue,
      activeSubMenuLink = _useMemo.activeSubMenuLink,
      navMenu = _useMemo.navMenu,
      subMenu = _useMemo.subMenu;

  var handleTabChange = useCallback(function (event, newValue) {
    var newItem = navMenu[newValue];
    var navLink = newItem.link || newItem.subMenuItems[0].link;

    if (navLink !== '#') {
      onNavigate(navLink);
    }
  }, [navMenu, onNavigate]);
  var handleSubItemClick = useCallback(function (link) {
    return function () {
      trackPendo('menu-item-click', {
        link: link
      });

      if (link !== '#') {
        onNavigate(link);
      }
    };
  }, [onNavigate]);
  return /*#__PURE__*/React.createElement(OuterWrapper, null, /*#__PURE__*/React.createElement(InnerWrapper, null, /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(PureCarsMeridianLogo, null)), /*#__PURE__*/React.createElement(MenuWrapper, null, /*#__PURE__*/React.createElement(MenuColumnWrapper, {
    $level: 'primary'
  }, /*#__PURE__*/React.createElement(Tabs, {
    orientation: "vertical",
    value: isUndefined(activeValue) ? false : activeValue,
    onChange: handleTabChange,
    variant: "fullWidth",
    indicatorColor: "secondary",
    textColor: "secondary",
    "aria-label": "nav menu",
    TabIndicatorProps: {
      style: {
        backgroundColor: getColorPrimarySelector('main')(theme)
      }
    }
  }, navMenu.map(function (_ref4) {
    var _ref4$attributes = _ref4.attributes,
        attributes = _ref4$attributes === void 0 ? {} : _ref4$attributes,
        name = _ref4.name,
        Icon = _ref4.icon;
    return /*#__PURE__*/React.createElement(Tab, Object.assign({
      key: name,
      icon: Icon && /*#__PURE__*/React.createElement(Icon, null),
      label: name
    }, attributes));
  }))), /*#__PURE__*/React.createElement(MenuColumnWrapper, {
    $level: 'secondary'
  }, /*#__PURE__*/React.createElement(List, {
    component: "nav"
  }, subMenu.map(function (_ref5) {
    var name = _ref5.name,
        link = _ref5.link;
    var menuActive = link === activeSubMenuLink;
    return /*#__PURE__*/React.createElement(ListItem, {
      className: "menu-panel-item".concat(menuActive ? ' menuActive' : ''),
      button: true,
      key: name,
      onClick: handleSubItemClick(link)
    }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(SubItemTypography, {
      $menuActive: menuActive
    }, name)));
  }))))));
}
export default /*#__PURE__*/memo(MultiAppMenuPanel);